/**
 * Gemeinsame Versteck-Auswahl-Komponente für Gewächshaus/Rolltisch/Labor.
 * Rendering + Filterung sind zentral hier — die Tabs behalten ihre eigene
 * State-Verwaltung (Index oder ID, je nach bestehendem Muster des Tabs).
 */

export interface ExpandableHideout {
  expansionType:  string | null;
  expansionLevel: number;
}

/** Filtert Verstecke auf einen ausgebauten Slot-Typ (mind. Stufe 1, nicht nur "im Umbau"). */
export function filterHideoutsByExpansion<T extends ExpandableHideout>(
  hideouts: T[],
  expansionType: 'GROW_ROOM' | 'LABOR',
): T[] {
  return hideouts.filter((h) => h.expansionType === expansionType && h.expansionLevel > 0);
}

export interface HideoutSelectorButton {
  /** Wert für das data-Attribut (Index als String oder Versteck-ID, je nach Aufrufer). */
  key:        string;
  label:      string;
  isSelected: boolean;
}

function esc(s: string): string {
  return s.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
}

/** Rendert die gemeinsame Versteck-Auswahl-Tableiste. Leer wenn nur 1 (oder 0) Verstecke. */
export function renderHideoutSelectorTabs(buttons: HideoutSelectorButton[], dataAttr: string): string {
  if (buttons.length <= 1) return '';
  const btns = buttons.map((b) =>
    `<button class="hideout-selector-tab${b.isSelected ? ' is-active' : ''}" data-${dataAttr}="${esc(b.key)}">${esc(b.label)}</button>`,
  ).join('');
  return `<div class="hideout-selector-tabs">${btns}</div>`;
}

/** Leerzustand-Hinweis wenn kein passendes Versteck existiert (statt leerem/kaputtem Dropdown). */
export function renderHideoutSelectorEmpty(hint: string): string {
  return `<p class="hideout-selector-empty">${esc(hint)}</p>`;
}
